<template>
  <ComparisonLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/compare/notion.mjs";
</script>
